import type { NavigationType } from "web_myplann/Utils/WebViewModel";

export const isNavigationSupported = (
	supportedNavigationTypes: readonly NavigationType[] | undefined,
	type: NavigationType,
): boolean => supportedNavigationTypes?.includes(type) ?? false;
